export default function Marquee() {
  const items = [
    "KUBWALO PRIVATE BLEND",
    "LEAVE A LASTING IMPRESSION",
    "SIGNATURE SCENTS",
    "CRAFTED FOR UNFORGETTABLE MOMENTS",
    "30 ML PARFUM · ROLL-ON OILS",
  ];
  const row = [...items, ...items, ...items];
  return (
    <div className="relative overflow-hidden bg-[#121212] gold-hairline-t gold-hairline-b py-4 select-none" data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-sans-body text-[10px] sm:text-xs uppercase tracking-[0.4em] text-[#C6A15B]/70 px-6">
                {t}
                <span className="ml-12 text-[#D4AF37]/50">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
